import {
  Utensils,
  ShoppingCart,
  Sparkles,
  Laptop,
  Car,
  CreditCard,
  Building2,
  type LucideIcon,
} from "lucide-react";
import { ClienteSegmento } from "@workflow/types";

export const CLIENTE_SEGMENTO_ICON_MAP: Record<ClienteSegmento, LucideIcon> = {
  [ClienteSegmento.ALIMENTOS_BEBIDAS]: Utensils,
  [ClienteSegmento.VAREJO]: ShoppingCart,
  [ClienteSegmento.SAUDE_BELEZA]: Sparkles,
  [ClienteSegmento.TECNOLOGIA]: Laptop,
  [ClienteSegmento.AUTOMOTIVO]: Car,
  [ClienteSegmento.SERVICOS_FINANCEIROS]: CreditCard,
  [ClienteSegmento.OUTROS]: Building2,
};
